import React, { Component } from 'react';
import { connect } from 'react-redux';
import { arrayIsNotEmpty, getOnlyUnique, isDefined } from '../../../../../utils';
import BarChart from '../../../Chart/components/BarChart';

//const teams = [
//    { id: 0, name: 'All Teams', values: [ { name: "RES", value: 70 }, { name: "CSAT", value: 61 }, { name: "JibeSession", value: 840 }] },
//    { id: 0, name: 'Team 1', values: [{ name: "ASAT", value: 65 }, { name: "RES", value: 69 }, { name: "CSAT", value: 67 }, { name: "JibeSession", value: 740 }] },
//    { id: 0, name: 'Team 2', values: [{ name: "ASAT", value: 72 }, { name: "RES", value: 77 }, { name: "CSAT", value: 72 }, { name: "JibeSession", value: 780 }] },
//];

class BarChartContainer extends Component {
    constructor(props) {
        super(props);
    }

    //componentDidMount() {

    //}

    render() {
        const
            {
                teamsCalibrationStats,
                selectedTeams,
                calibratedOnSurveyQuestions,
            } = this.props;

        if (!isDefined(teamsCalibrationStats) || !isDefined(calibratedOnSurveyQuestions)) {
            return <div></div>
        }

        const filteredTeamsCalibrationStats = (selectedTeams && teamsCalibrationStats)
            ? teamsCalibrationStats.filter(t => (selectedTeams.some(st => st.id == t.aggregationId))
                || t.aggregationName === "All Teams")
            : teamsCalibrationStats;

        if (!isDefined(filteredTeamsCalibrationStats)) {
            return <div></div>;
        }

        var teamsNames = filteredTeamsCalibrationStats.map(p => p.aggregationName).filter(getOnlyUnique);
        if (!isDefined(teamsNames)) {
            return <div></div>;
        }

        const teamsForBarChart = teamsNames.map(teamName => {
            let valuesForQ = [];
            calibratedOnSurveyQuestions.map(cq => {
                const questionValue = filteredTeamsCalibrationStats.find(a => a.questionCode === cq.questionCode && a.aggregationName === teamName);
                const tempName = cq.questionCode === 'NPS' ? 'CSAT' : cq.questionCode;
                valuesForQ.push({ name: tempName, value: isDefined(questionValue) ? questionValue.overalSuccessRatePercent : undefined },)
            });

            const teamStats = filteredTeamsCalibrationStats.find(a => a.aggregationName === teamName);
            const teamJibeSessionCount = isDefined(teamStats) ? teamStats.sessionCnt : 0;
            valuesForQ.push({ name: "JibeSession", value: teamJibeSessionCount });
            return {
                name: teamName,
                values: valuesForQ
            }
        });
        
        return <div>
            <BarChart teams={teamsForBarChart} loading={false} changePeriod={this.changePeriod} />
        </div>
    }
}

const select = state => ({});

export default connect(select)(BarChartContainer);